import { TemplatesApi } from '../../../../api/templatesApi';
import { FileContext } from '../../../../contexts/FileContext';
import { PermissionsContext } from '../../../../contexts/PermissionsContext';
import { Template } from '../../../../interfaces/Templates';
import Loader from '../../../../shared/components/Loader';
import { CUSTOM_FORMAT, CUSTOM_IMPORT } from '../../../../shared/constants/constants';
import UpdateGlobalTemplateDialog from './Dialogs/UpdateGlobalTemplateDialog';
import './TemplatesSlider.scss';
import { IconButton } from '@mui/material';
import { SovosTooltip } from 'mosaic-react';
import { EditOutlined } from 'mosaic-react-icons';
import { Dispatch, FC, SetStateAction, useContext, useEffect, useState } from 'react';

interface TemplateSliderProps {
	setSelectedTemplate: Dispatch<SetStateAction<Template>>;
	onGlobalTemplateEditSelect: (template: Template) => void;
}

const TemplateSlider: FC<TemplateSliderProps> = (props: TemplateSliderProps) => {
	const { setSelectedTemplate, onGlobalTemplateEditSelect } = props;
	const [boxSelected, setBoxSelected] = useState<string>('');
	const [globalTemplates, setGlobalTemplates] = useState<Template[]>([]);
	const [isFetchingTemplates, setIsFetchingTemplates] = useState<boolean>(false);
	const [isUserEnableToEditGlobalTemplate, setIsUserEnableToEditGlobalTemplate] = useState(false);
	const [isDisableEditGlobalTemplateButton, setDisableEditGlobalTemplateButton] = useState<boolean>(false);
	const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
	const [templateSelected, setTemplateSelected] = useState<Template>({ id: '', name: '' });
	const { selectedFiles } = useContext(FileContext);
	const { isUserPermissionAllowed } = useContext(PermissionsContext);
	const fileId = selectedFiles[0]?.id;

	const checkUpdateGlobalTemplatePermission = (): boolean => {
		return isUserPermissionAllowed('BD_U_GLOBAL_TEMPLATE') ?? process.env.NODE_ENV === 'development';
	};

	const handleGlobalTemplateEditClick = (): void => {
		onGlobalTemplateEditSelect(templateSelected);
		setIsOpenDialog(false);
	};

	const handleGlobalTemplateEditSelect = (template: Template): void => {
		setTemplateSelected(template);
		setIsOpenDialog(true);
	};

	const handleTemplateSelect = (template: Template): void => {
		setBoxSelected(template.id);
		setSelectedTemplate(template);
	};

	useEffect(() => {
		setDisableEditGlobalTemplateButton(!Boolean(fileId));
	}, [fileId]);

	useEffect(() => {
		setIsFetchingTemplates(true);
		TemplatesApi.getGlobalTemplates()
			.then(response => {
				setGlobalTemplates(response);
				setIsUserEnableToEditGlobalTemplate(checkUpdateGlobalTemplatePermission());
			})
			.finally(() => setIsFetchingTemplates(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{isFetchingTemplates ? (
				<Loader className='templates-slider__loader' />
			) : (
				globalTemplates &&
				globalTemplates.length > 0 && (
					<div className='scrollbox'>
						<ul className='list'>
							<li
								className={boxSelected === CUSTOM_FORMAT ? 'templates-slider__box-selected' : 'templates-slider__box'}
								onClick={() => handleTemplateSelect({ id: CUSTOM_FORMAT, name: CUSTOM_IMPORT })}
							>
								<p>{CUSTOM_FORMAT}</p>
							</li>
							{globalTemplates.map(template => (
								<li
									key={template.id}
									className={boxSelected === template.id ? 'templates-slider__box-selected' : 'templates-slider__box'}
									onClick={() => handleTemplateSelect(template)}
								>
									<p>{template.name}</p>
									{isUserEnableToEditGlobalTemplate && (
										<div style={{ paddingLeft: 20 }}>
											<SovosTooltip title='edit global template'>
												<div>
													<IconButton
														disabled={isDisableEditGlobalTemplateButton}
														onClick={() => handleGlobalTemplateEditSelect(template)}
														size='small'
													>
														<EditOutlined fontSize='inherit' />
													</IconButton>
												</div>
											</SovosTooltip>
										</div>
									)}
								</li>
							))}
						</ul>
					</div>
				)
			)}
			<UpdateGlobalTemplateDialog
				isDialogOpen={isOpenDialog}
				onValueGlobalTemplateEditClick={handleGlobalTemplateEditClick}
				onClose={() => setIsOpenDialog(false)}
			/>
		</>
	);
};

export default TemplateSlider;
